import { useCallback } from 'react';

import { useCurrentJob, useDownloadPdf } from '../../../../hooks';

export interface ContainerComponentChildrenArgs {
  onClick: () => void;
  isSubmitting: boolean;
}

export interface ContainerComponentProps {
  children: (args: ContainerComponentChildrenArgs) => JSX.Element;
}

const ContainerComponent = ({ children }: ContainerComponentProps) => {
  const { downloadPdf, isSubmitting } = useDownloadPdf();
  const { jobInfo, jobCompanyInfo, introduction } = useCurrentJob();

  const onClick = useCallback(() => {
    if (
      !jobInfo ||
      !jobCompanyInfo ||
      (jobInfo?.introduced_to && !introduction)
    )
      return;
    downloadPdf(jobInfo, jobCompanyInfo, introduction);
  }, [jobInfo, jobCompanyInfo, introduction, downloadPdf]);

  return children({
    onClick,
    isSubmitting,
  });
};

ContainerComponent.displayName = 'JobSidebar-DownloadButton-container';

export default ContainerComponent;
